import * as T from 'three';

// TODO(three): las escenas 3D se ajustaron a ojo con three r144, que trataba los colores hex como lineales (modo
// "legacy"). Desde r152 three los convierte de sRGB a lineal por defecto, y eso cambia su aspecto. Hasta revisar los
// colores de cada escena se mantiene el modo anterior (el sorteo virtual ya funciona en los dos modos). Las luces
// tienen el mismo problema: los renderers que las calibraron en modo legacy usan renderer.useLegacyLights = true,
// que three r165 elimina; para pasar de r164 hay que recalibrar sus intensidades.
// Nota: un <Canvas> de react-three-fiber activa el modo moderno al montarse (como ya pasaba con fiber 8).
T.ColorManagement.enabled = false;
